module.exports = __webpack_public_path__ + "static/4-a362e9ba5c00be7baabd02426812df43.jpg";